import React, { useState } from 'react';
import { Editor } from '../Editor';
import { Preview } from '../Preview';

const SectionEditor = ({
  label = 'Contenu personnalisé',
  value = '',
  onChange,
  placeholder = 'Ajoutez du contenu personnalisé...',
  defaultOpen = true,
}) => {
  const [isEditing, setIsEditing] = useState(defaultOpen);

  return (
    <div className="mt-6 border border-gray-200 bg-white rounded-md p-4">
      <div className="flex justify-between items-center mb-4">
        <span className="font-semibold text-gray-700">{label}</span>
        <button
          type="button"
          onClick={() => setIsEditing(!isEditing)}
          className="flex items-center text-sm text-primary hover:underline"
        >
          {isEditing ? (
            'Aperçu'
          ) : (
            <>
              <span className="mr-2">✏️</span>
              Modifier
            </>
          )}
        </button>
      </div>

      {isEditing ? (
        <Editor value={value} onChange={onChange} placeholder={placeholder} />
      ) : (
        <div className="text-justify">
          {value ? (
            <Preview value={value} />
          ) : (
            <span className="text-gray-400 italic">
              Aucun contenu personnalisé
            </span>
          )}
        </div>
      )}
    </div>
  );
};

export default SectionEditor;
